<script lang="ts">
    import {currency} from "../../../utils";
    import {ItemPrice} from "../../../interfaces/item-price.class";

    export let title: string;
    export let prices: Array<ItemPrice>;
</script>
<fieldset class="mb-ii">
    <legend class="mb-0">
        {title}
    </legend>
    <table class="naui-table w-100 my-1">
        <thead>
        <tr>
            <th>
                <div>Item</div>
            </th>
            <th>
                <div>Código | Descripción B.BRAUN</div>
            </th>
            <th>
                <div>Precio de puja</div>
            </th>
            <th>
                <div>Precio a ofertar</div>
            </th>
        </tr>
        </thead>
        <tbody>
        {#each prices as item}
            <tr>
                <td>
                    <div>{item.number || ''}</div>
                </td>
                <td>
                    <div>{item?.product?.label}</div>
                </td>
                <td>
                    <div>{currency.format(item.bidPrice)}</div>
                </td>
                <td>
                    <div>{currency.format(item.unitOfferPrice)}</div>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
</fieldset>